var exports = {
  "GF": "ReportFlowPreview.module__messageScroller___TG5tdF",
  "BK": "ReportFlowPreview.module__messageContent___TG5tdF",
  "Kg": "ReportFlowPreview.module__userCard___TG5tdF",
  "fz": "ReportFlowPreview.module__userText___TG5tdF",
  "nT": "ReportFlowPreview.module__userName___TG5tdF",
  "a1": "ReportFlowPreview.module__userTag___TG5tdF",
};

module.exports = exports;
